import React, { useEffect, useState, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import Loader from '../utility/Loader';
import styles from './productpage.module.css'
import { Link } from 'react-router-dom/cjs/react-router-dom';
import authservice from '../Authentication/service/authservice';
import { ButtonStyle } from "../UIElements/Buttons/ButtonStyle";
import Modal from "react-modal";
import { Button } from 'react-bootstrap';
import mart from '../../assets/mart.png';
import TextDecoration from '../utility/TextDecoration';
import LargeRectangle from "../advertisements/LargeRectangle";
import BillBoard from "../advertisements/BillBoard";
import sty from '../listings/forms/addpost.module.css';
import { validEmailRegex, strongPasswordRegex, usernameRegex, mobilenumberRegex, validateForm } from '../RegxConst'
import ReactPaginate from 'react-paginate';
import SetAdvertiseLocation from "../SetAdvertiseLocation";
import { TermsAndConditions } from "../Authentication/Registration/TermsAndConditions";
import { container, notifyUser, type } from '../utility/notifyUser';
import { DatePicker, TimePicker } from 'antd';
import moment from "moment";


const ServicePage = (props) => {
  const { id } = useParams();
  const { martname } = useParams();
  const [services, setServices] = useState([]);
  const [cart, setCart] = useState({});
  const [currentIndex, setCurrentIndex] = useState({});
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [martDetails, setMartDetails] = useState(null);
  const [martStatus, setMartStatus] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [cartItems, setCartItems] = useState([]);

  const userNameAvailabilityTimerRef = useRef(null);
  const [showCartModal, setShowCartModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [pendingProduct, setPendingProduct] = useState(null);
  const [cartMartId, setCartMartId] = useState(localStorage.getItem("cartMartId"));
  const [cartClearing, setCartClearing] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const shareLinkRef = useRef(null);
  const [showInfoPopup, setShowInfoPopup] = useState({});
  const [selectedSizes, setSelectedSizes] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);

  const [username, setUsername] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmpassword, setConfirmpassword] = useState('');
  const [contact_number, setContactNumber] = useState('');
  const [email_address, setEmailAddress] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [checked, setChecked] = useState(false);
  const [radioError, setRadioError] = useState('');
  const [checkError, setCheckError] = useState('');
  const [errors, setErrors] = useState({});
  const [open, setOpen] = useState([]);
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [termsModel, setTermsModel] = useState({
    open: false,
    model_type: '',
  });
  const [fullAddress, setFullAddress] = useState([]);
  const selectedState = useRef([]);
  const selectedCity = useRef([]);
  const selectedLocality = useRef([]);
  const selectedNeighbourhood = useRef([]);
  const addressOptions = useRef([]);
  const stateValidation = useRef(null);
  const cityValidation = useRef(null);
  const localityValidation = useRef(null);
  const neighbourhoodValidation = useRef(null);
  const [workingHours, setWorkingHours] = useState([]);
  const [selectedDate, setSelectedDate] = useState({});
  const [selectedTime, setSelectedTime] = useState({});



  const generateSlots = (openingTime, closingTime, intervalMinutes = 30) => {
    const slots = [];
    const start = new Date(`1970-01-01 ${openingTime}`);
    const end = new Date(`1970-01-01 ${closingTime}`);

    let current = new Date(start);
    while (current <= end) {
      const formatted = current
        .toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true })
        .replace("am", "AM")
        .replace("pm", "PM");   // ✅ force uppercase AM/PM

      slots.push(formatted);
      current = new Date(current.getTime() + intervalMinutes * 60000);
    }
    return slots;
  };


  const getSlotsForDay = (date) => {
    if (!date) return [];

    const jsDate = date instanceof Date ? date : date.toDate();

    const dayIndex = jsDate.getDay();
    const day = dayNameMap[dayIndex];

    const wh = workingHours.find(
      (w) => w && w.day && w.day.toLowerCase() === day.toLowerCase()
    );

    if (!wh || !wh.openingTime || !wh.closingTime) return [];

    return generateSlots(wh.openingTime, wh.closingTime);
  };



  const weekdayOrder = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  const dayNameMap = {
    0: "sunday",
    1: "monday",
    2: "tuesday",
    3: "wednesday",
    4: "thursday",
    5: "friday",
    6: "saturday",
  };

  useEffect(() => {
    if (services && services.length > 0) {
      const wh = services[0].workingHours || [];
      const sorted = [...wh].sort(
        (a, b) =>
          weekdayOrder.indexOf(a.day.toLowerCase()) -
          weekdayOrder.indexOf(b.day.toLowerCase())
      );
      setWorkingHours(sorted);
    }
  }, [services]);

  const isDateAllowed = (date) => {
    const jsDate = date.toDate();
    const day = dayNameMap[jsDate.getDay()];
    console.log("Checking date:", jsDate, "=> day:", day, "Allowed?",
      workingHours.some((wh) => wh.day.toLowerCase() === day.toLowerCase())
    );

    return workingHours.some(
      (wh) => wh.day.toLowerCase() === day.toLowerCase()
    );
  };

  const closeModal = () => {
    setTermsModel({
      open: false,
      model_type: '',
    });
  };

  const openModal = (type) => {
    setTermsModel({
      open: true,
      model_type: type,
    });
  }

  useEffect(() => {
    const fetchFullAddress = async () => {
      Loader.runSpinner();
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hpmgr/listing/getallstates`);
        setFullAddress(response.data);
      } catch (error) {
        console.error('Error fetching address data:', error);
      } finally {
        Loader.stopSpinner();
      }
    };

    fetchFullAddress();
  }, []);


  const _handleState = (selectedStates) => {
    if (selectedStates.length)
      selectedState.current = selectedStates.map(p => p.value);
  }

  const _handleCity = (cities) => {
    if (cities.length)
      selectedCity.current = cities.map(p => p.value);
  };

  const _handleLocality = (localities) => {
    if (localities.length)
      selectedLocality.current = localities.map(p => p.value);
  };

  const _handleNeighbourhood = (neighs) => {
    if (neighs.length)
      selectedNeighbourhood.current = neighs.map(p => p.value);
  };



  const handleSubmit = (event) => {
    event.preventDefault();

    localStorage.setItem('state', selectedState.current[0]);

    localStorage.setItem('city', selectedCity.current[0]);

    localStorage.setItem('locality', selectedLocality.current[0]);

    localStorage.setItem('neighbourhood', selectedNeighbourhood.current[0]);

    if (!checked) {
      setCheckError("Please Check The Check Box to Agree Upon The Terms & Conditions and Privacy Policy.");
    } else {
      setCheckError("");
    }


    if (checked && validateForm(errors)) {
      const data = {
        userName: username,
        firstName,
        lastName,
        password,
        mobileNumber: contact_number,
        email: email_address,
        referralKey: null,
        stateId: selectedState.current[0],
        cityId: selectedCity.current[0],
        localityId: selectedLocality.current[0],
        neighbourhoodId: selectedNeighbourhood.current[0],
        hasBusiness: false,
        canWriteContent: false,
        canCreateVideo: false,
        canCreatePhoto: false,
        canInfluence: false,
        canDoDigitalMarketing: false,
        canDoPRJournalism: false,
        yearlyAccount: false,
        monthlyPrepaidAccount: false,
        freeAccount: true,
        halfYearlyPrepaidAccount: false,
        noTargetHalfYearlyAccount: false,
        quarterlyPrepaidAccount: false,
      };

      if (selectedState.length < 1) {
        setOpen(true);
        notifyUser("Location", "Select Any State", "danger");
        return;
      }

      else if (cityValidation.current) {
        if (selectedCity.length < 1) {
          setOpen(true);
          notifyUser("Location", "Select Any City", "danger");
          return;
        }

        else if (localityValidation.current) {
          if (selectedLocality.length < 1) {
            setOpen(true);
            notifyUser("Location", "Select Any Locality", "danger");
            return;
          }

          else if (neighbourhoodValidation.current) {
            if (selectedNeighbourhood.length < 1) {
              setOpen(true);
              notifyUser("Location", "Select Any Neighbourhood", "danger");
              return;
            }
            else {
              setOpen(false);
              localStorage.getItem('neighbourhood', selectedNeighbourhood.current[0])
              axios.post(process.env.REACT_APP_BACKEND_URL + '/abmgr/auth/save', data).then(response => {
                Loader.stopSpinner();
                if (response.data)
                  props.history.push('/activation-success/' + props.match.params.verify)
              }).catch(error => {
                if (error.response)
                  notifyUser("Registration", error.response.data, "danger")
              })
            }
          }
          else {
            setOpen(false);
            localStorage.getItem('locality', selectedLocality.current[0])
            axios.post(process.env.REACT_APP_BACKEND_URL + '/abmgr/auth/save', data).then(response => {
              Loader.stopSpinner();
              if (response.data)
                props.history.push('/activation-success/' + props.match.params.verify)
            }).catch(error => {
              if (error.response)
                notifyUser("Registration", error.response.data, "danger")
            })
          }
        }
        else {
          setOpen(false);
          localStorage.getItem('city', selectedCity.current[0])
          axios.post(process.env.REACT_APP_BACKEND_URL + '/abmgr/auth/save', data).then(response => {
            Loader.stopSpinner();
            if (response.data)
              props.history.push('/activation-success/' + props.match.params.verify)
          }).catch(error => {
            if (error.response)
              notifyUser("Registration", error.response.data, "danger")
          })
        }
      }
      else {
        setOpen(false);
        localStorage.getItem('state', selectedState.current[0])
        axios.post(process.env.REACT_APP_BACKEND_URL + '/abmgr/auth/save', data).then(response => {
          Loader.stopSpinner();
          if (response.data)
            props.history.push('/activation-success/' + props.match.params.verify)
        }).catch(error => {
          if (error.response)
            notifyUser("Registration", error.response.data, "danger")
        })
      }
    }


  };

  const handleSizeChange = (productId, selectedSizeObj) => {
    setSelectedSizes((prev) => ({
      ...prev,
      [productId]: selectedSizeObj,
    }));
  };


  const toggleInfoPopup = (productId) => {
    setShowInfoPopup((prev) => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };

  const showShareDialog = () => setIsDialogOpen(true);
  const hideShareDialog = () => setIsDialogOpen(false);

  const copyToClipboard = () => {
    if (shareLinkRef.current) {
      shareLinkRef.current.select();
      document.execCommand('copy');
    }
  };

  const shareTo = (platform) => {
    const businessName = martname.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-')
    const baseUrl = `${window.location.origin}/mart/${businessName}/${id}/services}`;
    let url = '';

    switch (platform) {
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(baseUrl)}`;
        break;
      case 'whatsapp':
        url = `https://api.whatsapp.com/send?text=${encodeURIComponent(baseUrl)}`;
        break;
      case 'twitter':
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(baseUrl)}`;
        break;
      case 'skype':
        url = `https://web.skype.com/share?url=${encodeURIComponent(baseUrl)}`;
        break;
      case 'telegram':
        url = `https://t.me/share/url?url=${encodeURIComponent(baseUrl)}`;
        break;
      case 'snapchat':
        // Snapchat doesn’t support direct link sharing via URL; consider custom integration
        alert("Snapchat sharing not supported directly.");
        return;
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(baseUrl)}`;
        break;
      case 'gmail':
        url = `mailto:?subject=Check this out&body=${encodeURIComponent(baseUrl)}`;
        break;
      default:
        return;
    }

    window.open(url, '_blank');
  };

  const businessName = martname.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-')

  const shareUrl = `${window.location.origin}/mart/${businessName}/${id}/services`;

  const fetchMartDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/get-mart/${id}`
      );
      setMartDetails(response.data);
      setModalIsOpen(true);
    } catch (error) {
      console.error("Error fetching mart details:", error);
    }
  };

  const fetchMartStatusDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/get-mart/${id}`
      );
      setMartStatus(response.data.open);
    } catch (error) {
      console.error("Error fetching mart details:", error);
    }
  };

  useEffect(() => {
    const initialIndex = {};
    services.forEach((service) => {
      initialIndex[`${service.id}`] = 0;
    });
    setCurrentIndex(initialIndex);
  }, [services]);

  const handleNext = (productId, size, totalImages) => {
    setCurrentIndex((prev) => {
      const key = `${productId}_${size}`;
      return {
        ...prev,
        [key]: (prev[key] + 1) % totalImages,
      };
    });
  };

  const fetchCartFromBackend = async () => {
    const userId = authservice.getCurrentUserid();
    if (!userId) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/booking/get-bag/?paymentMode=PHONEPE`,
        null
      );

      if (response.data && response.data.items) {
        const cartData = {};
        const selectedDates = {};
        const selectedTimes = {};

        response.data.items.forEach(item => {
          const key = String(item.serviceOfferingId);

          cartData[key] = item.quantity;
          selectedDates[key] = moment(item.appointmentDate);
          selectedTimes[key] = item.appointmentTime;
        });

        setCart(cartData);
        setSelectedDate(selectedDates);
        setSelectedTime(selectedTimes);


        localStorage.setItem("cart", JSON.stringify(cartData));
      }
    } catch (error) {
      console.error("Error fetching cart from backend:", error);
    }
  };



  const handlePrev = (productId, size, totalImages) => {
    setCurrentIndex((prev) => {
      const key = `${productId}_${size}`;
      return {
        ...prev,
        [key]: (prev[key] - 1 + totalImages) % totalImages,
      };
    });
  };

  const handleClearCart = async () => {
    setShowCartModal(false);
    setCartClearing(true);
    setPendingProduct(null);

    const userId = authservice.getCurrentUserid();

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/booking/get-bag?paymentMode=Wallet`
      );

      if (response.data && response.data.items.length > 0) {
        await Promise.all(
          response.data.items.map(item =>
            axios.delete(
              `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/sbooking/remove-item/{itemId}?paymentMode=Wallet`
            )
          )
        );
      }

      localStorage.removeItem("cart");
      localStorage.setItem("cartMartId", id);
      setCart({});
      setCartMartId(id);

      setTimeout(() => {
        setCartClearing(false);
        if (pendingProduct) {
          setPendingProduct(null);
        }
      }, 300);
    } catch (error) {
      console.error("❌ Error clearing cart:", error);
      setCartClearing(false);
    }
  };

  const selectedProducts = useMemo(() => {
    return selectedCategory ? services.filter(p => p.category === selectedCategory) : services;
  }, [selectedCategory, services]);

  useEffect(() => {
    fetchMartStatusDetails()
    fetchProducts(0);

    if (authservice.getCurrentUserid() !== null) {
      fetchCartFromBackend();
    }
    window.scroll(0, 0)
  }, []);

  const fetchProducts = async (page = 0) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/booking/mart/${id}?page=${page}`);
      const formattedProducts = response.data.data.map(service =>
      ({
        ...service,
        price: service.price,
        available: service.workingHours,
        productImage: service.images[0] || "default-image.jpg"
      })
      );
      setServices(formattedProducts);

      setCurrentPage(page);
      setPageCount(response.data.pageCount || 1);

      const uniqueCategories = [...new Set(response.data.data.map(p => p.category))];
      setCategories(uniqueCategories);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    fetchProducts(selectedPage);
  };


  const getKey = (service) => String(service.id);

  const handleAddToCart = async (service) => {
    const cartKey = getKey(service);
    const date = selectedDate[cartKey];
    const time = selectedTime[cartKey];

    if (!date || !time) {
      setErrors((prev) => ({
        ...prev,
        [cartKey]: "Please select both date and time before adding to cart."
      }));
      return;
    }

    setErrors((prev) => {
      const updated = { ...prev };
      delete updated[cartKey];
      return updated;
    });

    const userId = authservice.getCurrentUserid();
    if (!userId) { setShowLoginModal(true); return; }

    const currentMartId = id;

    if (cartMartId && cartMartId !== currentMartId) {
      setPendingProduct({ service });
      setShowCartModal(true);
      return;
    }

    const newQuantity = (cart[cartKey] || 0) + 1;

    setCart(prev => {
      const updated = { ...prev, [cartKey]: newQuantity };
      localStorage.setItem("cart", JSON.stringify(updated));
      localStorage.setItem("cartMartId", currentMartId);
      setCartMartId(currentMartId);
      return updated;
    });

    try {
      const data = {
        serviceOfferingId: service.id,
        quantity: newQuantity,
        appointmentDate: date.format("YYYY-MM-DD"),
        appointmentTime: time,

        paymentMode: "Wallet"
      };
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/booking/add-item`,
        data,
      );
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };


  const handleIncreaseQuantity = async (service) => {
    const cartKey = getKey(service);
    const date = selectedDate[cartKey];
    const time = selectedTime[cartKey];

    if (!date || !time) {
      setErrors((prev) => ({
        ...prev,
        [cartKey]: "Please select both date and time before increasing quantity."
      }));
      return;
    }

    // clear error
    setErrors((prev) => {
      const updated = { ...prev };
      delete updated[cartKey];
      return updated;
    });

    const userId = authservice.getCurrentUserid();
    if (!userId) { setShowLoginModal(true); return; }

    const currentMartId = id;
    if (cartMartId && cartMartId !== currentMartId) {
      setPendingProduct({ service });
      setShowCartModal(true);
      return;
    }

    const newQuantity = (cart[cartKey] || 0) + 1;

    setCart(prev => {
      const updated = { ...prev, [cartKey]: newQuantity };
      localStorage.setItem("cart", JSON.stringify(updated));
      return updated;
    });

    try {
      const data = {
        serviceOfferingId: service.id,
        quantity: newQuantity,
        appointmentDate: date.format("YYYY-MM-DD"),
        appointmentTime: time,

        paymentMode: "PHONEPE"
      };

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/booking/add-item`,
        data
      );
    } catch (error) {
      console.error("Error increasing quantity:", error);
    }
  };


  const handleDecresaeQuantity = async (service) => {
    const cartKey = getKey(service);
    const date = selectedDate[cartKey];
    const time = selectedTime[cartKey];

    if (!date || !time) {
      setErrors((prev) => ({
        ...prev,
        [cartKey]: "Please select both date and time before decreasing quantity."
      }));
      return;
    }

    // clear error
    setErrors((prev) => {
      const updated = { ...prev };
      delete updated[cartKey];
      return updated;
    });

    const userId = authservice.getCurrentUserid();
    if (!userId) { setShowLoginModal(true); return; }

    const currentMartId = id;
    if (cartMartId && cartMartId !== currentMartId) {
      setPendingProduct({ service });
      setShowCartModal(true);
      return;
    }

    const newQuantity = Math.max((cart[cartKey] || 0) - 1, 0);

    setCart(prev => {
      const updated = { ...prev };
      if (newQuantity === 0) delete updated[cartKey];
      else updated[cartKey] = newQuantity;
      localStorage.setItem("cart", JSON.stringify(updated));
      return updated;
    });

    try {
      const data = {
        serviceOfferingId: service.id,
        quantity: newQuantity,
        appointmentDate: date.format("YYYY-MM-DD"),
        appointmentTime: time,

        paymentMode: "PHONEPE"
      };

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/booking/add-item`,
        data
      );
    } catch (error) {
      console.error("Error decreasing quantity:", error);
    }
  };

  const resetCartItem = async (serviceId, date, time) => {
    const cartKey = String(serviceId);

    setCart(prev => {
      const updated = { ...prev };
      delete updated[cartKey];
      localStorage.setItem("cart", JSON.stringify(updated));
      return updated;
    });

    try {
      const userId = authservice.getCurrentUserid();
      if (!userId) return;

      const data = {
        serviceOfferingId: serviceId,
        quantity: 0,
        appointmentDate: date ? date.format("YYYY-MM-DD") : null,
        appointmentTime: time || null,
        paymentMode: "PHONEPE"
      };

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/booking/add-item`,
        data
      );
    } catch (error) {
      console.error("Error resetting cart item:", error);
    }
  };



  const redirect = (url) => {
    if (url) {
      const fixedUrl = url.startsWith("http://") || url.startsWith("https://")
        ? url
        : `https://${url}`;
      window.open(fixedUrl, "_blank");
    }
  };

  // const uniqueProducts = Array.from(
  //   new Map(remainingProducts.map((p) => [p.id, p])).values()
  // );

  const uniqueProductsSelected = Array.from(
    new Map(selectedProducts.map((p) => [p.id, p])).values()
  );

  const handleUserName = (e) => {
    e.preventDefault();
    if (userNameAvailabilityTimerRef.current) clearTimeout(userNameAvailabilityTimerRef.current);
    const userNameInput = e.target.value;
    setUsername(userNameInput);
    const updatedErrors = { ...errors };
    userNameAvailabilityTimerRef.current = setTimeout(async () => {
      if (userNameInput.length > 3 && userNameInput.length < 16) {
        if (usernameRegex.test(userNameInput)) {
          try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/auth/checkusername?userName=${userNameInput}`);
            updatedErrors.username = response.data;
          } catch (error) {
            updatedErrors.username = 'Error checking username availability';
          }
        } else {
          updatedErrors.username = 'Username contains invalid characters';
        }
      } else {
        updatedErrors.username = userNameInput.length < 4 ? 'Username should be minimum of 4 characters' : 'Too long username';
      }
      setErrors(updatedErrors);
    }, 1000);
  };

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let updatedErrors = errors;
    if (value) {
      switch (name) {
        case 'email_address': {
          errors.email_address =
            validEmailRegex.test(value)
              ? ''
              : 'Email is Not Valid!';
          break;
        }
        case 'password': {
          if (value.length < 8)
            errors.password = 'Password should be minimum of 8 characters and must contain atleast 1 Lowercase , 1 Uppercase , 1 Numeric and 1 Special Character'
          else
            errors.password = strongPasswordRegex.test(value)
              ? ""
              : 'Password Must Contain at Least 1 Lowercase or 1 Uppercase , 1 Numeric and 1 Special Character';
          errors.confirmpassword = confirmpassword && value !== confirmpassword ? 'Password Does Not Match' : ""
          break;
        }
        case 'confirmpassword':
          errors.confirmpassword = (value === password ? '' : 'Password Does Not Match');
          break;
        case 'contact_number': {
          errors.contact_number =
            mobilenumberRegex.test(value)
              ? (value.length < 10)
                ? 'Mobile Number Must Have 10 Digits'
                : ''
              : 'Invalid Mobile Number (Hint: Do not enter STD/ISO code)'
          break;
        }
        default:
          break;
      }
      setErrors(updatedErrors);
    } else {
      errors[name] = '';
    }
  }

  return (
    <div className={styles.admin_view_head}>
      <div className={`col-md-2 add_button animated_back_button text-right d-none d-md-block ${styles.bckBtn}`}>
        <ButtonStyle type="button" className="form-control btn btn-block btn_font"
          handleClick={() => props.history.push("/mart")}>&nbsp; &laquo; &nbsp; Go Back </ButtonStyle>
      </div>
      {martStatus === false ? (
        <div className={styles.martClosedContainer}>
          <img
            src={mart} // Replace with actual path
            alt="Mart Closed"
            className={styles.martClosedGif}
          />
        </div>
      ) : (
        <>
          <Modal isOpen={showCartModal} onRequestClose={() => setShowCartModal(false)}
            className={styles.modalContent} overlayClassName={styles.modalOverlay}>
            <div className={styles.martDetails}>
              <h3 className={styles.product_name}>Clear Cart?</h3>
              <p><strong>You already have services from a different mart. Do you want to clear your cart and add this service?</strong></p>
              <div className={styles.modalButtons}>
                <Button variant="danger" className="secondary" onClick={handleClearCart} disabled={cartClearing}>
                  {cartClearing ? "Clearing..." : "Yes, Clear Cart"}
                </Button>&nbsp;
                <Button className="secondary" variant="secondary" onClick={() => setShowCartModal(false)}>No</Button>
              </div>
            </div>
          </Modal>
          <Modal isOpen={showLoginModal} onRequestClose={() => setShowLoginModal(false)}
            className={styles.modalContent} overlayClassName={styles.modalOverlay}>
            <div className={styles.martDetails}>
              <h3 className={styles.product_name}>Add To Cart?</h3>
              <p><strong>To add this service in the cart, you have to <span
                type="button"
                style={{ color: 'navy' }}
                onClick={() => setShowRegistrationModal(true)}
              >
                Register
              </span> or <Link style={{ color: 'navy' }} to="/login/user">login</Link>  your account.</strong></p>
              <div className={styles.modalButtons}>
                <Button className="secondary" variant="secondary" onClick={() => setShowLoginModal(false)}>No</Button>
              </div>
            </div>
          </Modal>
          <Modal isOpen={showRegistrationModal} onRequestClose={() => setShowRegistrationModal(false)} className={styles.modalContent} overlayClassName={styles.modalOverlay}>
            <Button variant="danger" onClick={() => setShowRegistrationModal(false)} className="popup-close-btn">&times;</Button>
            <TermsAndConditions closeModal={closeModal} terms={termsModel} />
            <form onSubmit={handleSubmit}>
              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label} col-form-label`} htmlFor="title">Name*</label>
                </div>
                <div className="col-12 col-md-8 pb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="First Name"
                    name="firstName"
                    required
                    value={firstName}
                    noValidate
                    onChange={(e) => setFirstName(e.target.value)}
                    onInput={handleChange}
                  />
                </div>
                <div className="col-12 col-md-4"></div>
                <div className="col-12 col-md-8">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Last Name"
                    name="lastName"
                    required
                    value={lastName}
                    noValidate
                    onChange={(e) => setLastName(e.target.value)}
                    onInput={handleChange}
                  />
                </div>
              </div>

              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="title">User name*</label>
                </div>
                <div className="col-12 col-md-8">
                  <input type="text" className="form-control" placeholder="User name"
                    name="username" required value={username} noValidate autoComplete="new-password"
                    onChange={(e) => setUsername(e.target.value)}
                    onInput={handleUserName}
                  />
                  {errors.username && <div className="text-danger">{errors.username}</div>}
                </div>
              </div>


              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="desc">Password*</label>
                </div>
                <div className="col-12 col-md-8">
                  <input type="password" className="form-control" placeholder="Password"
                    name="password" autoComplete="new-password" required
                    value={password} noValidate
                    onChange={(e) => setPassword(e.target.value)}
                    onInput={handleChange}
                  />
                  {errors.password && <div className="text-danger">{errors.password}</div>}

                </div>
              </div>
              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="title">Confirm password*</label></div>
                <div className="col-12 col-md-8">
                  <input type="password" className="form-control" placeholder="Confirm password"
                    name="confirmpassword" required value={confirmpassword} noValidate
                    onChange={(e) => setConfirmpassword(e.target.value)}
                    onInput={handleChange}
                  />
                  {errors.confirmpassword && <div className="text-danger">{errors.confirmpassword}</div>}

                </div>
              </div>

              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="desc">Mobile number*</label>
                </div>
                <div className="col-12 col-md-8">
                  <input className="form-control" placeholder="Mobile number" noValidate maxLength="10"
                    name="contact_number" required value={contact_number}
                    onChange={(e) => setContactNumber(e.target.value)}
                    onInput={handleChange}
                  />
                  {errors.contact_number && <div className="text-danger">{errors.contact_number}</div>}

                </div>
              </div>
              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="desc">Email address*</label>
                </div>
                <div className="col-12 col-md-8">
                  <input className="form-control" placeholder="Email address" name="email_address"
                    required value={email_address} noValidate
                    onChange={(e) => setEmailAddress(e.target.value)}
                    onInput={handleChange}
                  />
                  {errors.email_address && <div className="text-danger">{errors.email_address}</div>}
                </div>
              </div>
              <div className="form-group row col-12 text-left">
                <div className="col-12 col-md-4">
                  <label className={`${styles.reg_form_section_label}`} htmlFor="desc">Location*</label>
                </div>
                <div className="col-12 col-md-8"></div>

                <div className="col-12 col-md-8">
                  <SetAdvertiseLocation
                    setFilterValidationMethod={props.setLocationValidationMethod}
                    allLocations={fullAddress}
                    selectedStates={selectedState.current}
                    selectedCities={selectedCity.current}
                    selectedLocalities={selectedLocality.current}
                    selectedNeighbourhoods={selectedNeighbourhood.current}
                    _handleState={_handleState}
                    _handleCity={_handleCity}
                    _handleLocality={_handleLocality}
                    _handleNeighbourhood={_handleNeighbourhood}
                    addressOptions={addressOptions.current}
                    setAddressOptions={(opts) => { addressOptions.current = opts; }}
                    labelClass="col-md-8"
                    setStateValidationMethod={(m) => { stateValidation.current = m; }}
                    setCityValidationMethod={(m) => { cityValidation.current = m; }}
                    setLocalityValidationMethod={(m) => { localityValidation.current = m; }}
                    setNeighbourhoodValidationMethod={(m) => { neighbourhoodValidation.current = m; }}
                  />
                </div>
              </div>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                />
                <label className="form-check-label">I have read and understood the&nbsp;
                  <span style={{ color: 'navy' }} type='button' onClick={() => { openModal('terms') }}>Terms &amp; Conditions,</span> and agree.</label>
              </div>
              {checkError && <div className="text-danger mb-2">{checkError}</div>}
              <div className="form-group row justify-content-center">
                <div className="col-12 text-center">
                  <button type="submit" className="btn btn-primary">Submit </button>
                </div>
              </div>
            </form>
          </Modal>
          <div className={`col-md-3 ${styles.cartButtonContainer} d-none d-md-flex m-5`}>
            <Link style={{ color: "#fff", backgroundColor: '#FF9933' }} type="button" className={`form-control btn btn-block ${styles.btn_font_share}`} to="/mart/service/cart">🛒 Go to Cart</Link>

            <i className={`${styles.infoIcon} fas fa-info-circle`} onClick={fetchMartDetails}>
              {/* <i className='fas fa-info-circle'></i> */}
            </i>
            <Link style={{ color: "#fff", backgroundColor: '#FF9933' }} type="button" className={`form-control btn btn-block ${styles.btn_font_share}`} onClick={showShareDialog}>
              Share
            </Link>
          </div>
          <div className={`row d-md-none ${styles.headerIcons}`}>
            <div className={`col-md-3 ${styles.leftIcon}`} style={{ width: '20%' }}>
              <button style={{ color: '#fff' }} type="button" className={`btn btn-block ${styles.backIcon}`}
                handleClick={() => props.history.push("/mart")}>Back </button>
            </div>&nbsp;
            <div className="col-md-6" style={{ width: '75%' }}>
              <div className={`row ${styles.rightIcon}`}>
                <div className={`col-md-3 ${styles.cartIcon}`}>
                  <Link type="button" className={`btn btn-block ${styles.btn_font_cart_mob}`} to="/mart/service/cart">🛒</Link>
                </div>
                <div className={`col-md-3 ${styles.cartIcon}`}>
                  <div className={`${styles.infoIcon} fas fa-info-circle`} onClick={fetchMartDetails}>i</div>
                </div>
                <div className={`col-md-3 ${styles.cartIcon}`}>
                  <Link style={{ color: '#fff' }} type="button" className={`btn btn-block ${styles.btn_font_share_mob}`} onClick={showShareDialog}><i class="fa fa-share-alt"></i></Link>
                </div>
              </div>
            </div>
          </div>
          {isDialogOpen && (
            <div className="sharedialog">
              <h2>Share this Clip</h2>
              <input
                type="text"
                value={shareUrl}
                ref={shareLinkRef}
                style={{ width: '80%', padding: '5px', marginBottom: '10px' }}
                readOnly
              />
              <button className="copylink" onClick={copyToClipboard}>
                <i className="fa fa-copy"></i>
              </button>
              <div className="sharebuttons">
                <div className="sharebutton fb" onClick={() => shareTo('facebook')}></div>
                <div className="sharebutton whatsapp" onClick={() => shareTo('whatsapp')}></div>
                <div className="sharebutton twitter" onClick={() => shareTo('twitter')}></div>
                <div className="sharebutton skype" onClick={() => shareTo('skype')}></div>
                <div className="sharebutton telegram" onClick={() => shareTo('telegram')}></div>
                <div className="sharebutton snapchat" onClick={() => shareTo('snapchat')}></div>
                <div className="sharebutton linkedin" onClick={() => shareTo('linkedin')}></div>
                <div className="sharebutton gmail" onClick={() => shareTo('gmail')}></div>
              </div>
              <button className="shareclose" onClick={hideShareDialog}>
                Close
              </button>
            </div>
          )}
          <div className={`row ${styles.filterContainer}`}>
            <label className={styles.filterLabel}>Select Category: &nbsp;
              <span className={styles.dropdown} onClick={() => setDropdownOpen(!dropdownOpen)}>
                <span className={styles.dropdownSelected}>
                  {selectedCategory || "All Categories"}
                </span>
                {dropdownOpen && (
                  <ul className={styles.dropdownList}>
                    <li
                      className={styles.dropdownItem}
                      onClick={() => { setSelectedCategory(""); setDropdownOpen(false); }}
                    >
                      All
                    </li>
                    {categories.map((category, index) => (
                      <li
                        key={index}
                        className={`${styles.dropdownItem} ${selectedCategory === category ? styles.active : ""}`}
                        onClick={() => { setSelectedCategory(category); setDropdownOpen(false); }}
                      >
                        {category}
                      </li>
                    ))}
                  </ul>
                )}
              </span>
            </label>
          </div>


          {selectedProducts.length > 0 && (
            <>
              <h3 className={styles.subheading}>Products</h3>
              <div className="row">
                {uniqueProductsSelected.map((service) => {
                  const cartKey = getKey(service);
                  return (
                    <div key={service.productId} className={`col-6 col-sm-4 col-lg-3 col-xl-2 col-xxl-2 ${styles.low_padding}`}>

                      <div className={styles.listing_card_video} style={{ opacity: service.available ? 1 : 0.5 }}>
                        <div className={styles.carousel_container}>
                          {service.images.length > 1 && (
                            <>
                              <a className={styles.prev_btn} onClick={() => handlePrev(service.id, service.images.length)}>
                                <a onClick={(e) => { e.preventDefault() }} className={styles.previous_round}>&#8249;</a>
                              </a>
                              <a className={styles.next_btn} onClick={() => handleNext(service.id, service.images.length)}>
                                <a onClick={(e) => { e.preventDefault() }} className={styles.next_round}>&#8250;</a>
                              </a>
                            </>
                          )}
                          <div className={styles.listing_thumb_image_video}>
                            <img
                              src={`${process.env.REACT_APP_IMAGES_URL}${service.images[currentIndex[`${service.id}`] || 0]}`}
                              alt="Product"
                              className={styles.product_img}
                            />
                          </div>
                        </div>
                        <div className={styles.listing_details}>
                          <h3 className={styles.product_name}>{service.serviceName}</h3>
                          <div className={styles.listing_address}>
                            <p>
                              <span className={styles.price}>Price: ₹{service.price}</span><br></br>
                              <span className={styles.website} onClick={() => toggleInfoPopup(service.id)}>Product Description</span><br></br>
                            </p>

                            <div className={styles.booking_filters}>
                              <DatePicker
                                value={selectedDate[cartKey] || null}
                                onChange={(date) => {
                                  setSelectedDate((prev) => ({ ...prev, [cartKey]: date }));

                                  if (cart[cartKey]) {
                                    resetCartItem(service.id, date, selectedTime[cartKey]);  // 🔥 reset
                                  }
                                }}
                                disabledDate={(date) => !isDateAllowed(date)}
                                placeholder="Select a date"
                                className={styles.date_picker}
                              />

                              <select
                                value={selectedTime[cartKey] || ""}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setSelectedTime((prev) => ({ ...prev, [cartKey]: value }));

                                  if (cart[cartKey]) {
                                    resetCartItem(service.id, selectedDate[cartKey], value); // 🔥 reset
                                  }
                                }}
                                className={styles.time_dropdown}
                              >
                                <option value="">Select time</option>
                                {(() => {
                                  const slots = getSlotsForDay(selectedDate[cartKey]);
                                  return slots.map((slot, i) => (
                                    <option key={i} value={slot}>{slot}</option>
                                  ));
                                })()}
                              </select>


                            </div>


                            <div className="d-flex justify-content-center">
                              <div className={styles.quantity_container}>
                                <i className={`${styles.info_btn} fas fa-info-circle`} onClick={() => toggleInfoPopup(service.id)}></i>
                              </div>
                              {(() => {
                                const qty = cart[String(service.id)] || 0;
                                return qty > 0 ? (
                                  <div className={styles.quantity_container}>
                                    <button className={styles.quantity_btn} onClick={() => handleDecresaeQuantity(service)}>-</button>
                                    <span className={styles.quantity}>{qty}</span>
                                    <button className={styles.quantity_btn} onClick={() => handleIncreaseQuantity(service)}>+</button>
                                  </div>
                                ) : (
                                  <div className={styles.quantity_container}>
                                    <button className={styles.add_to_cart} disabled={!selectedDate[cartKey] || !selectedTime[cartKey]} onClick={() => handleAddToCart(service)}>Add to Cart</button>
                                  </div>
                                );
                              })()}

                            </div>
                          </div>
                        </div>

                      </div>
                      {showInfoPopup[service.id] && (
                        <div className={styles.popup_overlay}>
                          <div className={styles.popup}>
                            <button className={styles.close_popup} onClick={() => toggleInfoPopup(service.id)}>X</button>
                            <div className={`${styles.carousel_container}`}>
                              {service.images.length > 1 && (
                                <>
                                  <a className={styles.prev_btn} onClick={() => handlePrev(service.id, service.size, service.images.length)}>
                                    <a onClick={(e) => { e.preventDefault() }} className={styles.previous_round}>&#8249;</a>
                                  </a>
                                  <a className={styles.next_btn} onClick={() => handleNext(service.id, service.size, service.images.length)}>
                                    <a onClick={(e) => { e.preventDefault() }} className={styles.next_round}>&#8250;</a>
                                  </a>
                                </>
                              )}
                              <div className={styles.listing_thumb_image_video}>
                                <img
                                  src={`${process.env.REACT_APP_IMAGES_URL}${service.images[currentIndex[`${service.id}`] || 0]}`}
                                  alt="Product"
                                  className={styles.popup_image}
                                />
                              </div>
                            </div>
                            <h3>{service.productName}</h3>
                            <p>{service.productDescription}</p>
                            <p>
                              <span className={styles.price}>Price: ₹{service.price}</span><br></br>
                              <span className={styles.website} onClick={() => redirect(service.webSite)}>{service.webSite ? <b>More Info</b> : null}</span>
                            </p>
                            <div className="d-flex justify-content-center">
                              <div className={styles.quantity_container}>
                                <button className={styles.add_to_cart} onClick={() => toggleInfoPopup(service.id)}>
                                  Close
                                </button>
                              </div> &nbsp;
                              {(() => {
                                const qty = cart[String(service.id)] || 0;
                                return qty > 0 ? (
                                  <div className={styles.quantity_container}>
                                    <button className={styles.quantity_btn} onClick={() => handleDecresaeQuantity(service)}>-</button>
                                    <span className={styles.quantity}>{qty}</span>
                                    <button className={styles.quantity_btn} onClick={() => handleIncreaseQuantity(service)}>+</button>
                                  </div>
                                ) : (
                                  <div className={styles.quantity_container}>
                                    <button className={styles.add_to_cart} onClick={() => handleAddToCart(service)}>Add to Cart</button>
                                  </div>
                                );
                              })()}

                            </div>
                          </div>
                        </div>
                      )}
                    </div>)
                })}
              </div>
              {pageCount > 1 && (
                <div className="pagination-container text-center">
                  <ReactPaginate
                    previousLabel={"← Prev"}
                    nextLabel={"Next →"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                    forcePage={currentPage}
                    disabledClassName="pagination_disable_next_prev"
                  />
                </div>
              )}
            </>
          )}

          <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            className={styles.modalContent}
            overlayClassName={styles.modalOverlay}
          >
            <Button variant="danger" className="popup-close-btn" onClick={() => setModalIsOpen(false)}>
              &times;
            </Button>
            {martDetails && (
              <div className={styles.martDetails}>
                <img
                  src={`${process.env.REACT_APP_IMAGES_URL}${martDetails.thumbnailImage}`}
                  alt="Mart Thumbnail"
                  className={styles.martImage}
                />
                <h2 className={styles.product_name}>{martDetails.martName}</h2>
                <p>{martDetails.businessDescription}</p>
                <p><strong>Address:</strong> {martDetails.businessAddress}</p>
                <p><strong>Contact Person:</strong> {martDetails.contactName}</p>
                <p><strong>Contact Number:</strong> {martDetails.contactNumber}</p>
                <p><strong>Mart Open: </strong> {martDetails.open ? 'Yes' : 'No'} </p>
                <Button className="secondary" variant="secondary" onClick={() => setModalIsOpen(false)}>
                  Cancel
                </Button>
              </div>
            )}
          </Modal>
        </>
      )}<br></br>
      <div className={`listings row ${sty.large_rect}`}>
        {!props.isAdmin && <LargeRectangle spot={"-1"} />}
      </div>
      <div className={`${sty.billBoard} row`} style={{ backgroundColor: '#e5e5f2', paddingTop: '100px', paddingBottom: '100px' }}>
        {!props.isAdmin && <BillBoard spot={"-1"} />}
      </div>
    </div>
  );
};

export default ServicePage;
